/* eslint-disable camelcase,no-undef */
import { fetchPosts, resetSelect, containClass, isMobile, truncate } from '../utilities/_utilities';

(function() {
    const nextNonce = Archive_Ajax.nextNonce;
    const ajaxUrl = Archive_Ajax.ajaxurl;
    // Get the content area of CPT Page Teamplete.
    const archiveContent = document.getElementById('archive-content');

    const ajax = {
        action: 'archive-filter',
        ajaxUrl,
        nextNonce,
    };

    let currentPageTitle = '';

    // Create Custom Select from existing select element.
    // eslint-disable-next-line no-unused-expressions
    isMobile() ? createSelect() : null;

    /* =============================================================================
    Search Form Submit Event
    =============================================================================== */
    const customSearchForm = document.getElementById('custom-search-form');

    customSearchForm.addEventListener('submit', event => {
        event.preventDefault();
        const searchTerm = document.getElementById('custom-search-input').value;
        if (isMobile()) {
            fetchPosts(ajax, archiveContent, 'post', { s: searchTerm }, adjustMobileFilter);
        } else {
            fetchPosts(ajax, archiveContent, 'post', { s: searchTerm });
        }
    });

    /* =============================================================================
    Dropdown Category filter for Archive
    =============================================================================== */
    const archiveCatFilters = document.querySelectorAll('.archive-cat-filter');
    const archiveCatFilterDesktop = document.getElementById('archive-cat-filter');

    const archiveCatFilterHandler = (e) => {
        const cat = isMobile() ? e.target.dataset.value : e.target.value;
        resetSelect(archiveCatFilterDesktop);
        fetchPosts(ajax, archiveContent, 'post', { cat });
    };

    if (archiveCatFilters && isMobile()) {
        archiveCatFilters.forEach((archiveCatFilter) => {
            archiveCatFilter.addEventListener('click', archiveCatFilterHandler);
        });
    } else {
        archiveCatFilterDesktop.addEventListener('change', archiveCatFilterHandler);
    }

    /* =============================================================================
    Dropdown Author filter for Archive
    =============================================================================== */
    const authorFilters = document.querySelectorAll('.archive-author-filter');
    const authorFiltersDesktop = document.getElementById('archive-author-filter');

    const authorFilterHandeler = (e) => {
        const author = isMobile() ? e.target.dataset.value : e.target.value;
        resetSelect(authorFiltersDesktop);
        fetchPosts(ajax, archiveContent, 'post', { author });
    };

    if (authorFilters && isMobile()) {
        authorFilters.forEach((authorFilter) => {
            authorFilter.addEventListener('click', authorFilterHandeler);
        });
    } else {
        authorFiltersDesktop.addEventListener('change', authorFilterHandeler);
    }

    /* =============================================================================
    Dropdown Year filter for Archive
    =============================================================================== */
    const yearFilters = document.querySelectorAll('.archive-year-filter');
    const yearFiltersDesktop = document.getElementById('archive-year-filter');

    const yearFiltersHandeler = (e) => {
        const year = isMobile() ? e.target.dataset.value : e.target.value;
        resetSelect(yearFiltersDesktop);
        fetchPosts(ajax, archiveContent, 'post', { year });
    };
    if (yearFilters && isMobile()) {
        yearFilters.forEach((yearFilter) => {
            yearFilter.addEventListener('click', yearFiltersHandeler);
        });
    } else {
        yearFiltersDesktop.addEventListener('change', yearFiltersHandeler);
    }

    /* =============================================================================
    Dropdown Tag filter for Archive
    =============================================================================== */
    const tagFilters = document.querySelectorAll('.archive-tag-filter');
    const tagFiltersDesktop = document.getElementById('archive-tag-filter');
    const tagFilterHandeler = (e) => {
        const tag = isMobile() ? e.target.dataset.value : e.target.value;
        resetSelect(tagFiltersDesktop);
        fetchPosts(ajax, archiveContent, 'post', { tag });
    };
    if (tagFilters && isMobile()) {
        tagFilters.forEach((tagFilter) => {
            tagFilter.addEventListener('click', tagFilterHandeler);
        });
    } else {
        tagFiltersDesktop.addEventListener('change', tagFilterHandeler);
    }

    /* =============================================================================
    Blog mobile filter
    =============================================================================== */

    const searchFilter = document.getElementById('cpt-mobile-search-filter');
    const searchAlphabet = document.getElementById('cpt-mobile-alphabet-filter');
    const archiveFilter = document.querySelector('.archive-filter');
    const cptSearchForm = document.getElementById('custom-search-form');

    searchFilter.addEventListener('click', function() {
        if (searchAlphabet) {
            searchAlphabet.setAttribute('disabled', '');
        }

        // Toggle Search Form
        if (containClass(customSearchForm, 'custom-search-form--active')) {
            customSearchForm.classList.remove('custom-search-form--active');
            searchAlphabet.removeAttribute('disabled');
        } else {
            customSearchForm.classList.add('custom-search-form--active');
        }
    });

    if (searchAlphabet) {
        searchAlphabet.addEventListener('click', function() {
            searchFilter.setAttribute('disabled', '');

            // Toggle Alphabet Filter
            if (containClass(archiveFilter, 'archive-filter--active')) {
                archiveFilter.classList.remove('archive-filter--active');
                searchFilter.removeAttribute('disabled');
            } else {
                archiveFilter.classList.add('archive-filter--active');
            }
        });
    }

    /**
     * Adjust mobile search filter header.
     *
     * @param {String} searchValue
     * @param {String} type
     */
    const adjustMobileFilter = (searchValue, type) => {
        const cptMobileRow = document.querySelector('.cpt-mobile-row');

        if (cptMobileRow) {
            // Update Page Title with current search term.
            const mobileTitle = document.querySelector('.rs-heading--mobile');

            // Create and Insert Clear Search button.
            const newNode = document.createElement('button');
            newNode.id = 'clear-search';
            newNode.classList.add('clear-search');
            newNode.setAttribute('style', 'margin-bottom: 24px');

            if (type === 'search') {
                newNode.innerHTML = `
                    <span class="icon-Undo_Icon"></span>
                    <span class="clear-search__text">Clear Search</span>
                `;
            } else if (type === 'letter' || type === 'cpt_cat') {
                newNode.innerHTML = `
                    <span class="icon-Undo_Icon"></span>
                    <span class="clear-search__text">Clear Filter</span>
                `;
            }

            // Clear filter or search button.
            newNode.addEventListener('click', function() {
                fetchPosts(ajax, archiveContent, 'post');
                this.remove();
                if (type === 'search') {
                    mobileTitle.innerText = currentPageTitle;
                    document.getElementById('custom-search-input').value = '';
                    // eslint-disable-next-line no-unused-expressions
                    searchAlphabet ? searchAlphabet.removeAttribute('disabled') : null;
                    // eslint-disable-next-line no-unused-expressions
                }
            });
            const parentDiv = cptSearchForm.parentNode;
            parentDiv.insertBefore(newNode, cptSearchForm);

            if (type === 'search') {
                currentPageTitle = mobileTitle.innerText;
                mobileTitle.innerText = truncate(searchValue, 15);
                // Hide Search Form.
                cptSearchForm.classList.remove('custom-search-form--active');
            } else if (type === 'cpt_cat') {
                customFilter.classList.remove('custom-filter--active');
            }
        }
    };

    const selectDefaultOption = () => {
        const allSelects = document.getElementsByTagName('select');
        Array.from(allSelects).forEach((select) => {
            const opt = document.createElement('option');
            opt.setAttribute('selected', true);
            opt.setAttribute('disabled', true);
            opt.innerHTML = select.getAttribute('placeholder-text');
            select.appendChild(opt);
        });
    };

    // eslint-disable-next-line no-unused-expressions
    !isMobile() ? selectDefaultOption() : null;

    /* =============================================================================
    To create custom select element.
    =============================================================================== */
    function createSelect() {
        const select = document.querySelectorAll('.rs-custom-select');
        let liElement;
        let ulElement;
        let optionValue;
        let iAddElement;
        let iRemoveElement;
        let optionText;
        let selectDropdown;
        let elementParentSpan;

        for (let select_i = 0, len = select.length; select_i < len; select_i++) {
            select[select_i].style.display = 'none';
            const elementId = select[select_i].getAttribute('data-id');
            const targetElement = document.querySelectorAll(`[data-id=${elementId}]`);
            wrapElement(targetElement[0], document.createElement('div'), select_i, select[select_i].getAttribute('placeholder-text'), elementId);

            for (let i = 0; i < select[select_i].options.length; i++) {
                liElement = document.createElement('li');
                optionValue = select[select_i].options[i].value;
                optionText = document.createTextNode(select[select_i].options[i].text);
                liElement.className = 'select-dropdown__list-item';
                liElement.setAttribute('data-value', optionValue);
                liElement.appendChild(optionText);
                ulElement.appendChild(liElement);

                liElement.addEventListener('click', function() {
                    displyUl(this);
                }, false);
            }
        }
        function wrapElement(el, wrapper, i, placeholder, elementId, filterItems) {
            el.parentNode.insertBefore(wrapper, el);
            wrapper.appendChild(el);

            document.addEventListener('click', function(e) {
                const clickInside = wrapper.contains(e.target);
                const dropdownButtons = document.querySelectorAll('.select-dropdown__button');
                if (!clickInside) {
                    const menu = wrapper.getElementsByClassName('select-dropdown__list');
                    menu[0].classList.remove('active');
                }

                if (dropdownButtons) {
                    dropdownButtons.forEach(button => {
                        if (button.classList.contains('open')) {
                            button.classList.remove('open');
                        } else {
                            button.classList.add('open');
                        }
                    });
                }
            });

            const buttonElement = document.createElement('button');
            const spanElement = document.createElement('span');
            const spanText = document.createTextNode(placeholder);
            iAddElement = document.createElement('span');
            iRemoveElement = document.createElement('span');
            ulElement = document.createElement('ul');

            wrapper.className = 'select-dropdown select-dropdown--' + i;
            buttonElement.className = 'select-dropdown__button select-dropdown__button--' + i;
            buttonElement.setAttribute('data-value', '');
            buttonElement.setAttribute('type', 'button');
            spanElement.className = 'select-dropdown select-dropdown--' + i;
            iAddElement.className = 'icon-Add_Icon';
            iRemoveElement.className = 'icon-Subtract_Icon';
            ulElement.className = 'select-dropdown__list select-dropdown__list--' + i + ' ' + elementId;
            ulElement.id = elementId;

            wrapper.appendChild(buttonElement);
            spanElement.appendChild(spanText);
            buttonElement.appendChild(spanElement);
            buttonElement.appendChild(iAddElement);
            buttonElement.appendChild(iRemoveElement);
            wrapper.appendChild(ulElement);
        }

        function displyUl(element) {
            if (element.tagName === 'BUTTON') {
                selectDropdown = element.parentNode.getElementsByTagName('ul');
                for (let i = 0, len = selectDropdown.length; i < len; i++) {
                    selectDropdown[i].classList.toggle('active');
                }
            } else if (element.tagName === 'LI') {
                const selectId = element.parentNode.parentNode.getElementsByTagName('select')[0];
                selectElement(selectId.dataset.id, element.getAttribute('data-value'));
                elementParentSpan = element.parentNode.parentNode.getElementsByTagName('span');
                element.parentNode.classList.toggle('active');
                if (isMobile()) {
                    let clearBlogFilter = document.getElementById('clear-blog-filter');
                    element.classList.add('selected');
                    const selectFilterHeader =  document.createElement('div');
                    // if clear blog filter is not exist, create and insert
                    if (!clearBlogFilter) {
                        selectFilterHeader.classList.add('rs-col-xs-12');
                        selectFilterHeader.classList.add('select-filter-header');
                        // eslint-disable-next-line no-unused-expressions
                        selectFilterHeader.innerHTML = '<button id="clear-blog-filter" class="select-filter-header__btn"><span class="icon-Undo_Icon"></span>Clear Filter</button>';
                    }
                    const mobileFilterHeader = document.querySelector('.cpt-mobile-row');
                    mobileFilterHeader.parentNode.insertBefore(selectFilterHeader, mobileFilterHeader.nextSibling);

                    // eslint-disable-next-line no-unused-expressions
                    archiveFilter.classList.contains('archive-filter--active') ? archiveFilter.classList.remove('archive-filter--active') : null;

                    clearBlogFilter = document.getElementById('clear-blog-filter');
                    clearBlogFilter.addEventListener('click', () => {
                        const buttonsSelect = document.querySelectorAll('.select-dropdown__button');
                        buttonsSelect.forEach(btnSelect => {
                            // eslint-disable-next-line no-unused-expressions
                            btnSelect.classList.contains('open') ? btnSelect.classList.remove('open') : null;
                        });
                        const filterHead = document.querySelector('.select-filter-header');
                        searchFilter.removeAttribute('disabled');
                        // eslint-disable-next-line no-unused-expressions
                        filterHead ? filterHead.remove() : null;
                        fetchPosts(ajax, archiveContent, 'post');
                    });
                } else {
                    elementParentSpan[0].textContent = element.textContent;
                    elementParentSpan[0].parentNode.setAttribute('data-value', element.getAttribute('data-value'));
                }
            }
        }

        function selectElement(id, valueToSelect) {
            // const element = document.getElementById(id);
            const element = document.querySelector(`[data-id=${id}]`);
            element.value = valueToSelect;
            element.setAttribute('selected', 'selected');
        }

        const buttonSelect = document.getElementsByClassName('select-dropdown__button');
        for (let i = 0, len = buttonSelect.length; i < len; i++) {
            buttonSelect[i].addEventListener('click', function(e) {
                e.preventDefault();
                (this.classList.contains('open') ? this.classList.remove('open') : this.classList.add('open'));
                displyUl(this);
            }, false);
        }
    };
})(Archive_Ajax);
